import type { TestTarget } from "../types/TestTarget";

/**
 * 指定ターゲットから親方向に辿り、最初の View の ID を返す。
 */
export function find_parent_view_id(
  targets: TestTarget[],
  targetId: string
): string | null {
  const byId = new Map(targets.map((t) => [t.id, t]));
  let current: string | undefined = targetId;
  const seen = new Set<string>();
  while (current && !seen.has(current)) {
    seen.add(current);
    const t = byId.get(current);
    if (!t) return null;
    if (t.type === "view") return t.id;
    current = t.parentId;
  }
  return null;
}

/**
 * 指定ルート（Service / Category 等）配下の全 View を収集する。
 * Category はフォルダー的コンテナのため透過して再帰下降し、ネストした Category も辿る。
 * View を発見したら収集しつつ、旧来の実装（全子孫フィルタ）との互換性を保つため
 * View 配下も引き続き再帰して View をネストした View も収集する。
 */
export function collect_views_under_root(
  targets: TestTarget[],
  rootId: string
): TestTarget[] {
  const out: TestTarget[] = [];
  const seen = new Set<string>();
  const dfs = (parentId: string): void => {
    for (const child of targets.filter((t) => t.parentId === parentId)) {
      if (seen.has(child.id)) continue;
      seen.add(child.id);
      if (child.type === "view") {
        out.push(child);
        // 旧来の実装との互換性のため View 配下も降りて View をネストした View も収集する
        dfs(child.id);
      } else if (child.type === "service" || child.type === "category") {
        // service / category 等のコンテナは配下へ降りる（View は収集しない）
        dfs(child.id);
      }
      // item / section / overlay / component 配下には View が存在しないため降りない
    }
  };
  dfs(rootId);
  return out;
}
